export const toggleShowProjectContextMenu = (projectid) => {
    return {
      type: 'TOGGLE_SHOW_PROJECT_CONTEXT_MENU',
      payload: {
        projectId: projectid,
      },
    };
  };